export default "__VITE_ASSET__DljAm3Zn__"